import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { NgClass } from '@angular/common';
import { CtaCardComponent } from '../cta-card/cta-card.component';
@Component({
  selector: 'app-content-block-cta-cards',
  templateUrl: './content-block-cta-cards.component.html',
  styleUrls: ['./content-block-cta-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, CtaCardComponent],
})
export class ContentBlockCtaCardsComponent extends ContentBlockBaseComponent {
  // block = input<ContentBlock[]>();

  get ctaCardsColumns() {
    const cards = this.block().ctaItems;
    if (!cards) {
      return;
    }

    if (this.block().compact) {
      return ' col-24 col-sm-12 col-lg-6';
    }

    switch (cards.length) {
      case 1:
        return 'col-md-24';

      default:
        return 'col-md-12';
    }
  }
}
